module.exports = __webpack_public_path__ + "img/expand_32.a934aeed.svg";